import { UserProvider } from './hooks/user'
import App from './App'
import { withProfiler } from '@sentry/react'

const Root = withProfiler(function Root() {
  return (
    <UserProvider>
      <App />
    </UserProvider>
  )
})

Root.displayName = 'AppRoot'

export default Root
